import * as React from "react";
import { graphql, Link } from "gatsby";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import Layout from "@app/Layout.tsx";
import Pagination from "@shared/ui/Pagination";
import "@styles/pmm.scss";

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

// SEO Meta
export const Head = (props) => {
  const canonical = `https://www.${process.env.GATSBY_DOMAIN}${props.location.pathname}`;

  let title;
  let description;

  if (props.location.pathname.startsWith('/updates/')) {
    const currentPage = props.pageContext.currentPage || 1;
    if (props.location.pathname === '/updates/' || props.pageContext.currentPage) {
      title = `${capitalizeFirstLetter(props.pageContext.title)}, page ${currentPage} — Dashly`;
      description = 'Dashly updates: learn more about the latest updates to our product'
    } else {
      title = `${capitalizeFirstLetter(props.pageContext.title)} — Dashly updates`;
      description = `Learn more about ${props.pageContext.title} in Dashly updates`
    }
  } else {
    title = "Dashly";
    description = 'Dashly updates: learn more about the latest updates to our product'
  }

  return (
      <>
        <title>{title}</title>
        <meta name="description" content={description}/>
        <link rel="canonical" href={canonical}/>
      </>
  );
};

export default class PmmPage extends React.Component {

  render() {
    return (
      <Layout className="page pmm-index post mt-5">
        <Container>
          <Row className="justify-content-lg-end d-none d-lg-flex">
            <Col lg={9}>
              <h1 className="h2 mb-3 mb-lg-4" dangerouslySetInnerHTML={{ __html: `${this.props.pageContext.title}` }} />
            </Col>
          </Row>

          {/* Навигация мобильная */}
          <Row className="d-lg-none mb-4">
            <Col>
              {(this.props.data.pmmJson && <Link to="/updates/"> ← Back</Link>) || (
                <Dropdown className="d-inline mx-2" autoClose="inside">
                  <Dropdown.Toggle id="dropdown-autoclose-inside">{this.props.pageContext.title}</Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="/updates/">All</Dropdown.Item>
                    {this.props.data.allBlogCategory.nodes.map((category) => (
                      <Dropdown.Item
                        href={`/updates/${category.slug}/`}
                        key={category.wp_id}
                        dangerouslySetInnerHTML={{ __html: `${category.name}` }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Col>
          </Row>

          <Row>
            {/* Навигация */}
            <Col xs={3} className="d-none d-lg-block font14px">
              <p className="mb-2">
                <Link to="/updates/">All</Link>
              </p>
              {this.props.data.allBlogCategory.nodes.map((category) => (
                <p key={category.wp_id} className="mb-2">
                  <Link to={`/updates/${category.slug}/`} dangerouslySetInnerHTML={{ __html: `${category.name}` }} />
                </p>
              ))}
            </Col>

            <Col cols={12} lg={9}>
              {(this.props.data.pmmJson && (
                <>
                  {/* Пост */}
                  <div className="post__box__categories mb-3">
                    {this.props.data.allBlogCategory.nodes.map(
                      (category) =>
                        this.props.data.pmmJson.categories.includes(Number(category.wp_id)) && (
                          <span
                            key={category.wp_id}
                            className="grey-text text-uppercase font14px me-1"
                            dangerouslySetInnerHTML={{ __html: category.name }}
                          />
                        ),
                    )}
                  </div>
                  <div
                    className="lightgrey-text my-4"
                    dangerouslySetInnerHTML={{ __html: `${this.props.data.pmmJson.date}` }}
                  />
                  <div
                    className="post__text"
                    dangerouslySetInnerHTML={{ __html: `${this.props.data.pmmJson.content}` }}
                  />
                </>
              )) || (
                <>
                  {/* Список постов */}
                  <Row>
                    {this.props.data.allPmmPost.edges.map((post) => (
                      <Col xs={12} className="mb-5" key={post.node.wp_id}>
                        <div className="postcard postcard--pmm">
                          <span className="postcard__box box-shadow box h-100 d-block">
                            {/* Категории */}
                            <div className="postcard__box__categories px-3 pt-3">
                              {this.props.data.allBlogCategory.nodes.map(
                                (category) =>
                                  post.node.categories.includes(Number(category.wp_id)) && (
                                    <span
                                      key={category.wp_id}
                                      className="lightgrey-text text-uppercase font14px me-1"
                                      dangerouslySetInnerHTML={{ __html: category.name }}
                                    />
                                  ),
                              )}
                            </div>
                            {/* Заголовок */}
                            <Link
                              to={`/updates/${post.node.slug}/`}
                              className="h4 postcard__box__title mt-3 px-3 mb-3 d-block"
                              dangerouslySetInnerHTML={{ __html: `${post.node.title}` }}
                            />
                            {/* Дата */}
                            <div
                              className="px-3 pb-3 font14px grey-text"
                              dangerouslySetInnerHTML={{ __html: `${post.node.date}` }}
                            />
                            {/* Описание */}
                            <div
                              className="px-3 pb-3 postcard__text"
                              dangerouslySetInnerHTML={{ __html: `${post.node.description}` }}
                            />
                          </span>
                        </div>
                      </Col>
                    ))}
                  </Row>
                  <Pagination
                    pages={this.props.pageContext.numPmmPages}
                    current={this.props.pageContext.currentPage}
                    path={this.props.pageContext.pagePath}
                  />
                </>
              )}
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query Pmm($id: Int!, $skip: Int!, $limit: Int!, $updateCategoryId: Int!) {
    pmmJson(wp_id: { eq: $id }) {
      title
      content
      categories
      date
    }
    allBlogCategory(filter: { wp_parent: { eq: $updateCategoryId }, count: { nin: 0 } }) {
      nodes {
        wp_id
        name
        slug
        wp_parent
      }
    }
    allPmmPost(filter: { categories: { in: [$id] } }, sort: { published: DESC }, limit: $limit, skip: $skip) {
      edges {
        node {
          wp_id
          title
          slug
          date
          description
          categories
          parentPage {
            slug
          }
        }
      }
    }
  }
`;
